import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { QuicklinkStrategy } from 'ngx-quicklink';
import { AuthGuard } from 'src/@vex/guards/auth.guard';
import { GuestGuard } from 'src/@vex/guards/guest.guard';
import { RoleGuard } from 'src/@vex/guards/role.guard';

const routes: VexRoutes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then(m => m.LoginModule),
    canActivate: [GuestGuard]
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  },

  {
    path: 'terms-and-conditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then(m => m.TermsAndConditionsModule)
  },
  {
    path: 'stereotype-kpi',
    loadChildren: () => import('./stereotype-kpi/stereotype-kpi.module').then(m => m.StereotypeKpiModule)
  },
  {
    path: '',
    component: CustomLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        redirectTo: '/',
        pathMatch: 'full'
      },
      {
        path: '',
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [RoleGuard],
        data: { roles: ['advisor_admin', 'advisor_user', 'stakeholder_admin', 'stakeholder_user'] }
      },
      {
        path: 'admin',
        loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [RoleGuard],
        data: { roles: ['advisor_admin', 'advisor_user'] }
      },
      {
        path: 'clients',
        loadChildren: () => import('./pages/clients/clients.module').then(m => m.ClientsModule),
        canActivate: [RoleGuard],
        data: { roles: ['advisor_admin', 'advisor_user'] }
      },
      {
        path: 'rules',
        loadChildren: () => import('./pages/lrps/rules/rules.module').then(m => m.RulesModule),
        canActivate: [RoleGuard],
        data: { roles: ['advisor_admin', 'advisor_user'] }
      },
      {
        path: 'questionnaires',
        canActivate: [RoleGuard],
        loadChildren: () => import('./pages/questionnaire/questionnaire.module').then(m => m.QuestionnaireModule),
        data: { roles: ['advisor_admin', 'advisor_user'] }
      },
      {
        path: 'assets',
        canActivate: [RoleGuard],
        loadChildren: () => import('./pages/assets/assets.module').then(m => m.AssetsModule),
        data: { roles: ['advisor_admin', 'advisor_user'] }
      },
      {
        path: 'account-settings',
        loadChildren: () => import('./pages/account-settings/account-settings.module').then(m => m.AccountSettingsModule)
      },
      {
        path: 'contributors',
        loadChildren: () => import('./pages/stakeholder/contributors/contributors.module').then(m => m.ContributorsModule),
        canActivate: [RoleGuard],
        data: { roles: ['stakeholder_admin', 'stakeholder_user'] }
      },
      {
        path: 'use-cases',
        loadChildren: () => import('./pages/stakeholder/use-case/use-case.module').then(m => m.UseCaseModule),
        canActivate: [RoleGuard],
        data: { roles: ['stakeholder_admin', 'stakeholder_user'] }
      },
      {
        path: 'resources',
        loadChildren: () => import('./pages/stakeholder/resources/resources.module').then(m => m.ResourcesModule),
        canActivate: [RoleGuard],
        data: { roles: ['stakeholder_admin', 'stakeholder_user'] }
      }
    ]
  },
  {
    path: '403',
    loadChildren: () => import('./pages/errors/error-403/error-403.module').then(m => m.Error403Module)
  },
  {
    path: '500',
    loadChildren: () => import('./pages/errors/error-500/error-500.module').then(m => m.Error500Module)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/errors/error-404/error-404.module').then(m => m.Error404Module)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: QuicklinkStrategy,
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
